import { NeoModel } from '@singularsystems/neo-core';
import { injectable } from 'inversify';
import { OidcAuthenticationServiceBase } from 'st-common/App/Services/Security/AuthenticationServiceBase';
import { AppService, AppTypes } from './AppService';
import { Types } from '../../Participants/ParticipantsTypes';
import { Types as AwardsTypes } from 'st-awards/AwardsTypes';

@injectable()
@NeoModel
export class OidcAuthenticationService extends OidcAuthenticationServiceBase {

    protected async afterUserLoaded(): Promise<void> {
        await super.afterUserLoaded();
        await AppService.get(AppTypes.AllocationManager.Services.AllocationManagerService).initialize();

        // Chatbot is participant-only functionality (server enforces Policies.IsParticipantUser via the
        // st_participant claim). Skip it when the loaded user has no participant context - e.g. an admin
        // whose token was just refreshed after ending a proxy session - otherwise the resulting 403 can
        // disrupt the signinSilent() call that triggered this user-loaded event (see proxy session end flow).
        if (this.user?.participantId) {
            await AppService.get(AppTypes.Clients.Services.ChatbotService).initialise();
        }

        await AppService.get(Types.Participants.Services.ParticipantConfigService).initialize();
        await AppService.get(AwardsTypes.Awards.Services.AwardsDataCache).initialize();
    }
}